// Disabled links
$(document).on("click", "a[disabled]", function(e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
});

// Attach dynamic click listeners
$(document).on("click", "[data-trigger=click]", function(e) {

    if ($(this).data()["preventDefault"]) {
        e.preventDefault();
    }

    var params = [];

    if ($(this).attr("data-params")) {
        params = eval("[" + $(this).attr("data-params") + "]");
    }

    params.push(e);

    var controller = eval($(this).attr("data-controller"));
    controller.apply(this, params);
});

// Mobile toggle menu
$(".js-toggle-nav").on("click", function(e) {
    e.preventDefault();

    $(".header__bottom").toggleClass("responsive");

});

// Floating labels
$(":input").on("focus", function() {

	var group = $(this).closest(".form__group");
	group.addClass("form__group--focused");

});

$(":input").on("blur", function() {
	
	var group = $(this).closest(".form__group");
	group.removeClass("form__group--focused");

});

$(":input").on("change", function() {

	var group = $(this).closest(".form__group");

	if (
		($(this).val() !== null && $(this).val() !== "") ||
	 	$(this).is("select")
	) {
		group.addClass("form__group--filled");
	}
	else {
		group.removeClass("form__group--filled");
	}

}).change();

$(":input").on("input", function() {

	var group = $(this).closest(".form__group");
	var append = group.find(".form__append-fix")

	append.html($(this).val().replace(new RegExp(" ", "g"), "&nbsp;"));

});

$(document).on('click', '.clever-link', function(e){
	if($(this).data('prevent')) {
		return false;
	} else {
		window.open($(this).data('link'), "_self");
	}
	
});

if ($(".product__thumb").length) {
    // Photoswipe init        
    $(".product__thumb").photoSwipe(
        ".lightbox-container",
        {
            bgOpacity: 0.8,
            shareEl: false,
            captionEl: false,
            tapToClose: true
        }
    );
}

if ($(".category-slider").length) {
    // Photoswipe init        
    $(".category-slider").photoSwipe(
        ".lightbox-container",
        {
            bgOpacity: 0.8,
            shareEl: false,
            captionEl: false,
            tapToClose: true
        }
    );
}

$('.floating__btn--telephone').on('click', function() {
	$('.phones-wrapper').toggleClass('visible');
});